export const SERVICES = [
  {
    n: "01",
    slug: "election-campaigns",
    title: "Election Campaigns",
    hindi: "चुनाव अभियान",
    color: "#FF3D8A",
    short: "Vidhan Sabha, Lok Sabha and Nagar Nigam campaigns — strategy, war room, booth game, result.",
    desc: "Our core. From ticket to tally we run the whole machine — constituency research, candidate positioning, manifesto and messaging, a 24x7 Hindi-first digital war room, booth-level voter data, rallies and roadshows, chunavi geet and polling-day turnout operations. For BJP, Congress, regional parties and independents.",
    tags: ["Campaign Strategy", "Digital War Room", "Booth & Voter Data", "Rallies & Roadshows", "Chunavi Geet", "Polling-Day Ops", "Surveys & IVR"],
    img: "https://images.unsplash.com/photo-1716047269726-56a1781be730?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    n: "02",
    slug: "branding",
    title: "Branding",
    hindi: "ब्रांडिंग",
    color: "#FF7A1A",
    short: "Identity systems for leaders, parties, businesses and institutions — logo to language.",
    desc: "A leader is a brand. So is a party unit, a township, a school or a startup. We build identity systems that hold up on a hoarding in Dewas and on an Instagram story in Delhi — naming, logo, colour and type, brand voice, personal branding for leaders, and the guidelines that keep it consistent for years.",
    tags: ["Logo & Identity", "Leader Personal Branding", "Brand Strategy", "Naming & Taglines", "Brand Guidelines", "Rebrands"],
    img: "https://images.unsplash.com/photo-1728537520855-515e2ee9aaa7?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    n: "03",
    slug: "pr",
    title: "PR & Media",
    hindi: "जनसंपर्क",
    color: "#2F6BFF",
    short: "Press, television, regional newsrooms, influencers and crisis communication — handled.",
    desc: "Relationships with Hindi and regional newsrooms across Indore, Malwa and Madhya Pradesh — plus national desks when the story deserves it. Press conferences, bytes, exclusives, op-eds, influencer PR, government IEC communication and a crisis desk that moves faster than the headline.",
    tags: ["Media Relations", "Press Conferences", "Crisis Communication", "Op-Eds & Interviews", "Influencer PR", "Government IEC"],
    img: "https://images.unsplash.com/photo-1709832279012-293766967250?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    n: "04",
    slug: "ads",
    title: "Advertising",
    hindi: "विज्ञापन",
    color: "#12A150",
    short: "Performance ads, political ads, OOH, TV, radio and print — every rupee tracked.",
    desc: "Meta and Google performance campaigns, political ad accounts with compliance handled, hoardings and wall branding, LED vans, newspaper and regional TV and radio buys — planned from one media calendar and reported on one dashboard. Cost per lead, cost per voter reached, nothing hidden.",
    tags: ["Meta & Google Ads", "Political Ads", "OOH & Hoardings", "TV, Radio & Print", "LED Vans", "Media Planning"],
    img: "https://images.unsplash.com/photo-1760262491785-4c4adcf649e8?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    n: "05",
    slug: "web",
    title: "Web & Tech",
    hindi: "वेब और टेक",
    color: "#5C8CFF",
    short: "Websites, campaign microsites, door-to-door apps, WhatsApp bots and lead systems.",
    desc: "Fast, mobile-first websites and landing pages; campaign microsites that go live in 72 hours; door-to-door and booth-management apps; WhatsApp bots and helplines; CRM and lead systems that ring a counsellor or karyakarta within ten minutes; SEO that ranks a leader's name before the opposition does.",
    tags: ["Websites & Landing Pages", "Campaign Microsites", "Door-to-Door Apps", "WhatsApp Bots", "CRM & Lead Systems", "SEO"],
    img: "https://images.unsplash.com/photo-1760262492479-85a9832b9034?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
  {
    n: "06",
    slug: "creatives",
    title: "Creatives",
    hindi: "क्रिएटिव",
    color: "#FF5FA2",
    short: "Reels, films, jingles, social creatives, motion graphics and photography — daily.",
    desc: "Our in-house Indore studio ships every day: reels and shorts with Hindi captions in 24 hours, campaign films and documentaries, chunavi geet and jingles, social media creative calendars, motion graphics, drone and event coverage, and photography that makes a leader look like a leader.",
    tags: ["Reels & Short-Form", "Films & Documentaries", "Jingles & Geet", "Social Creatives", "Motion Graphics", "Photography & Drone"],
    img: "https://images.unsplash.com/photo-1710987760447-e1777b1de284?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  },
];

export const SERVICE_NAMES = SERVICES.map((s) => s.title).concat("Not sure yet");

export const ORG_TYPES = ["Political Party", "Candidate / Leader", "Government Department", "Business / Brand", "NGO / Foundation", "Other"];

export const BUDGETS = [
  { id: "under-2l", label: "Under ₹2 Lakh" },
  { id: "2l-10l", label: "₹2L – ₹10L" },
  { id: "10l-50l", label: "₹10L – ₹50L" },
  { id: "50l-plus", label: "₹50L+" },
];

export const INDIAN_STATES = [
  "Madhya Pradesh", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
  "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
  "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
  "West Bengal", "Delhi", "Jammu & Kashmir", "Ladakh", "Chandigarh", "Puducherry", "Other",
];

export const FOUNDER = {
  name: "Anuj Tiwari",
  role: "Founder & Chief Strategist",
  hindi: "संस्थापक",
  photo: "/founder.jpg",
  phone: "+91 99199 99647",
  bio: "Anuj started ONWARD MEDIA in Indore with a camera, a laptop and one conviction — that elections in Madhya Pradesh are won in mohallas and mandis, not in Delhi boardrooms. He has since led war rooms for BJP and Congress candidates alike, from Indore Nagar Nigam wards to Lok Sabha constituencies, and built a team that treats every seat like it is the only one.",
  quote: "हम नारे नहीं बनाते। हम जनादेश बनाते हैं।",
};

export const PARTIES = [
  { short: "BJP", name: "Bharatiya Janata Party", color: "#FF7A1A" },
  { short: "INC", name: "Indian National Congress", color: "#19AAED" },
  { short: "IND", name: "Independent Candidates", color: "#F4F4F0" },
  { short: "REG", name: "Regional Parties & Alliances", color: "#FF3D8A" },
];

export const PARTY_OPTIONS = ["BJP", "INC (Congress)", "BSP", "SP", "AAP", "Independent", "Other party", "Not applicable"];

export const CONTACT = {
  email: "hello@onwardmedia.in",
  phone: "+91 99199 99647",
  phoneHref: "tel:+919919999647",
  whatsapp: "https://wa.me/919919999647?text=Namaste%20Anuj%20ji%2C%20I%20want%20to%20discuss%20a%20campaign%20with%20Onward%20Media.",
  address: ["Scheme 54, Vijay Nagar", "Indore, Madhya Pradesh 452010"],
};
